import './site.less';

import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { AriaLiveAnnouncer } from '@fluentui/react-components';
import { queryClient } from '@root/query';
import { i18n } from '@shared/i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { DfpFluentProvider } from '../DfpFluentProvider/DfpFluentProvider';

export interface SiteProps {
	children: React.ReactNode;
}

export const Site = (props: SiteProps) => (
	<BrowserRouter>
		<I18nextProvider i18n={i18n}>
			<div className="Site">
				<DfpFluentProvider>
					<AriaLiveAnnouncer>
						<QueryClientProvider client={queryClient}>
							<ReactQueryDevtools />
							{props.children}
						</QueryClientProvider>
					</AriaLiveAnnouncer>
				</DfpFluentProvider>
			</div>
		</I18nextProvider>
	</BrowserRouter>
);
